import type { Styles } from '@adornis/ass/style.js';
import type { ValueEvent } from '@adornis/base/utilTypes.js';
import '@adornis/bh-registration/client/bh-registration-product-filter.js';
import { Category } from '@adornis/buchungsheld-db/entities/category.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import type { EditorFunc } from '@adornis/html-based-buildify/client/types.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { filter, switchMap } from 'rxjs';
import type { HTMLBaseInstitutionProducts } from '../../../db/HTMLBaseInstitutionProductFilter.js';

export const editor: EditorFunc<HTMLBaseInstitutionProducts, {}> = ({
  content,
  contentController,
  controllerBaseKeyPath,
  host,
  translation,
}) => {
  return html`
    <node-institution-products-filter .content=${content} .host=${host}></node-institution-products-filter>
  `;
};

@customElement('node-institution-products-filter')
export class NodeInstitutionProductsFilter extends ChemistryLitElement {
  @property({ attribute: false }) content!: HTMLBaseInstitutionProducts;
  @property({ attribute: false }) host!: ChemistryLitElement;

  @state() private readonly _institutionID = new RXController(this, document.location.pathname.split('/')[2]);
  @state() private readonly _categories = new RXController(
    this,
    this._institutionID.observable.pipe(
      filter(Boolean),
      switchMap(institutionID => {
        return Category.getCategoriesByInstitution(institutionID)({
          institutionID: 1,
          name: 1,
          sortingWeight: 1,
          _id: 1,
          _class: 1,
        });
      }),
    ),
  );

  override render() {
    return html`
      <bh-registration-product-filter
        .filter=${this.content.filter}
        .timeframes=${[]}
        .productTopics=${[]}
        .categories=${this._categories.value ?? []}
        @update-filter=${(e: ValueEvent<{ key: string; value: any }>) => {
          this.content.filter[e.detail.value.key] = e.detail.value.value;
          this.host.requestUpdate();
        }}
      ></bh-registration-product-filter>
    `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {},
      },
    ] as Styles[];
  }
}
